import { BaseApi } from 'src/api/BaseApi';
import { DEMO_REPORTS, DEMO_REPORT_DETAILS, DEMO_REPORT_NOTES } from 'src/api/demo/reports';

class ReportsApi extends BaseApi {
  async fetchAll() {
    if (this.isDemo()) return DEMO_REPORTS;

    const response = await this.postRequest('reports/list');

    return response.data;
  }

  async fetchByID(reportID) {
    if (this.isDemo()) {
      return DEMO_REPORT_DETAILS[reportID] || DEMO_REPORT_DETAILS[1];
    }

    const formData = this.createFormData({
      reportID,
    });

    const response = await this.postRequest('reports/get', formData);

    return response.data;
  }

  async fetchByCompanyName(companyName) {
    if (this.isDemo()) {
      return DEMO_REPORTS.filter((report) => report.company.toLowerCase().includes(companyName.toLowerCase()));
    }

    const formData = this.createFormData({
      company: companyName,
    });

    const response = await this.postRequest('reports/list', formData);

    return response.data;
  }

  async create(companyName, startDate, endDate, externalEfforts) {
    if (this.isDemo()) {
      return Date.now();
    }

    const formData = this.createFormData({
      company: companyName,
      startDate,
      endDate,
    });

    if (externalEfforts) formData.append('externalEfforts', externalEfforts);

    const response = await this.postRequest('reports/create', formData);

    console.log('create report effort', response);

    return response.data;
  }

  async update(reportID, companyName, startDate, endDate, externalEfforts) {
    if (this.isDemo()) {
      return this.createDemoSuccessResponse({
        reportID,
        report: {
          id: reportID,
          company: companyName,
          startDate,
          endDate,
          externalEfforts,
          updatedAt: new Date().toISOString(),
        },
      });
    }

    const formData = this.createFormData({
      reportID,
    });

    if (companyName) formData.append('company', companyName);
    if (startDate) formData.append('startDate', startDate);
    if (endDate) formData.append('endDate', endDate);
    if (externalEfforts) formData.append('externalEfforts', externalEfforts);

    const response = await this.postRequest('reports/edit', formData);

    console.log('update report effort', response);

    return response.data;
  }

  async getNotes(reportID) {
    if (this.isDemo()) {
      return DEMO_REPORT_NOTES.filter((note) => note.reportID === reportID);
    }

    const formData = this.createFormData({
      reportID,
    });

    const response = await this.postRequest('reports/notes', formData);

    return response.data;
  }

  async addNote(reportID, userID, userType, noteContent) {
    if (this.isDemo()) {
      return this.createDemoSuccessResponse({
        id: Date.now(),
        note: {
          id: Date.now(),
          reportID,
          userID,
          userType,
          content: noteContent,
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString(),
        },
      });
    }

    const content = {
      userID,
      userType,
      content: noteContent,
    };

    const formData = this.createFormData({
      reportID,
      content: JSON.stringify(content),
    });

    const response = await this.postRequest('reports/notes/add', formData);
    return response.data;
  }

  async editNote(noteID, userID, userType, noteContent) {
    if (this.isDemo()) {
      return this.createDemoSuccessResponse({
        noteID,
        note: {
          id: noteID,
          userID,
          userType,
          content: noteContent,
          updatedAt: new Date().toISOString(),
        },
      });
    }

    const content = {
      userID,
      userType,
      content: noteContent,
    };

    const formData = this.createFormData({
      noteID,
      action: 'edit',
      content: JSON.stringify(content),
    });

    const response = await this.postRequest('reports/notes/edit', formData);
    return response.data;
  }

  async deleteNote(noteID) {
    if (this.isDemo()) {
      return this.createDemoSuccessResponse({
        noteID,
        deleted: true,
      });
    }

    const formData = this.createFormData({
      noteID,
      action: 'delete',
    });

    const response = await this.postRequest('reports/notes/edit', formData);
    return response.data;
  }
}

export const reportsApi = new ReportsApi();

